/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetDriversQueryParams, GetDrivers200, GetDrivers400, GetDriversQueryResponse } from '../entities/GetDrivers'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { getDriversResponseSchema } from './getDriversResponseSchema'
import { z } from 'zod'

export const getDriversQueryParamsSchema = z.object({
  active_last_45_days: z.boolean().optional(),
  drivee_city_id: z.number().int().optional(),
  drivee_id: z.number().int().optional(),
  limit: z.number().int().min(1).max(50),
  no_orders_14_to_20_days: z.boolean().optional(),
  no_orders_14_to_45_days: z.boolean().optional(),
  no_orders_21_to_30_days: z.boolean().optional(),
  no_orders_31_to_45_days: z.boolean().optional(),
  offset: z.number().int().min(0),
  phone: z.string().optional(),
  recruiter_id: z.string().optional(),
}) as unknown as ToZod<GetDriversQueryParams>

/**
 * @description OK
 */
export const getDrivers200Schema = z.lazy(() => getDriversResponseSchema) as unknown as ToZod<GetDrivers200>

/**
 * @description Bad Request
 */
export const getDrivers400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetDrivers400>

export const getDriversQueryResponseSchema = z.lazy(() => getDrivers200Schema) as unknown as ToZod<GetDriversQueryResponse>